import config from "./config";

export class MeasurementService {
  /**
   * Fetch the last 10 measurements from Azure Function
   * @returns {Promise<Array>} Array of measurement objects
   */
  static async getLast10Measurements() {
    try {
      const response = await fetch(
        `${config.azureFunctionUrl}/getLast10Measurements?code=${config.azureFunctionHostKey}`,
        {
          method: "GET",
        }
      );

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const payload = await response.json();

      return payload?.Value ?? payload;
    } catch (error) {
      console.error("Error fetching measurements:", error);
      throw error;
    }
  }

  /**
   * Add a new measurement via Azure Function
   * @param {Object} measurementData - The measurement data to add
   * @returns {Promise<Object>} Response from the Azure function
   */
  static async addMeasurement(measurementData) {
    try {
      const response = await fetch(
        `${config.azureFunctionUrl}/addMeasurement?code=${config.azureFunctionHostKey}`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(measurementData),
        }
      );

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      return await response.json();
    } catch (error) {
      console.error("Error adding measurement:", error);
      throw error;
    }
  }

  /**
   * Delete a measurement via Azure Function
   * @param {string} id - The measurement ID to delete
   * @returns {Promise<Object>} Response from the Azure function
   */
  static async deleteMeasurement(RowKey) {
    try {
      const response = await fetch(
        `${config.azureFunctionUrl}/delMeasurement/${RowKey}?code=${config.azureFunctionHostKey}`,
        {
          method: "DELETE",
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      return await response.json();
    } catch (error) {
      console.error("Error deleting measurement:", error);
      throw error;
    }
  }

  /**
   * Get all measurements via Azure Function
   * @returns {Promise<Array>} Array of all measurement objects
   */
  static async getAllMeasurements() {
    try {
      const response = await fetch(
        `${config.azureFunctionUrl}/getAllMeasurements?code=${config.azureFunctionHostKey}`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const data = await response.json();

      // Transform the Azure function response to match the expected format
      return data.map((measurement) => ({
        id: measurement.Id,
        measurement1: measurement.Measurement1,
        measurement2: measurement.Measurement2,
        durationMinutes: measurement.DurationMinutes,
        micronsPerMinute: measurement.MicronsPerMinute,
        timestamp: measurement.Timestamp,
        measurementTimestamp: measurement.Timestamp, // Add this for the table display
      }));
    } catch (error) {
      console.error("Error fetching all measurements:", error);
      throw error;
    }
  }
}

export default MeasurementService;

